// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__2yKIz","logos":"style_logos__39I6E","school":"style_school__7LaoN","user":"style_user__16kPo","info":"style_info__3ZwKa","avatar":"style_avatar__1OiDD"};